module.exports = __webpack_public_path__ + "img/GW.92d3a388.svg";